module.exports = __webpack_public_path__ + "static/img/bg-es.5019f212.png";